import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee,faUser } from '@fortawesome/free-solid-svg-icons';

export default function CheckBox({name, value, tick, usersCount, onCheck}) {
      return (
            <div className= "select-role-row clearfix">
                <div className="roles-checkbox-list-col custom-control custom-checkbox float-left">
                    <input
                    name={name}
                    id ={value}
                    type="checkbox"
                    value={value}
                    checked={tick || false}
                    onChange={onCheck}
                    className="custom-control-input"
                    />
                    <label className="custom-control-label" htmlFor={value}>{value}</label>
                </div>
                {name === "select-all"?<div></div>:<div className="float-right"><FontAwesomeIcon className="" icon={faUser} /><sup className="text-primary"><label className="" htmlFor={usersCount}>({usersCount})</label></sup></div>}
            </div>
      );
}